import { z } from "zod/mini"

const UIDConfigSchema = z.object({
	label: z.nullish(z.string()),
	useAsTitle: z.optional(z.boolean()),
	placeholder: z.optional(z.string()),
})

export const UIDModelSchema = z.object({
	type: z.literal("UID"),
	fieldset: z.nullish(z.string()),
	config: z.optional(UIDConfigSchema),
})

export type UIDModel = z.infer<typeof UIDModelSchema>
